import React from 'react';

import { SurveyCreatePage, SurveyEditPage } from './SurveyCreatePage';
import { SurveyDetailsPage } from './SurveyDetailsPage';
import { SurveysPage } from './SurveysPage';

export const surveysRoutes = [
  {
    path: '',
    element: <SurveysPage />,
  },
  {
    path: 'new',
    element: <SurveyCreatePage />,
  },
  {
    path: ':globalId',
    element: <SurveyDetailsPage />,
  },
  {
    path: ':globalId/edit',
    element: <SurveyEditPage />,
  },
];
